import React, {lazy, Suspense} from 'react';
import {Route, Switch} from 'react-router-dom';
import TermsOfUseModal from 'shared/terms-of-use-modal/terms-of-use-modal';
import {EducationPhase} from '../../types/enums';
import ShareDataModal from '../../components/share-data-modal/share-data-modal';
const WelcomeModal = lazy(() => import('src/components/CollegeSearch/welcome-modal'));
const ActivitiesModal = lazy(() => import('shared/college-success/components/activities-modal'));
const NewEarningsModal = lazy(
  () => import('shared/notification-center/new-earnings-modal/containers')
);
const ReferralModal = lazy(
  () => import('src/components/student-referral-modal/student-referral-modal')
);
const VideoModal = lazy(() => import('../../components/video-modal/video-modal'));
const StudentWelcomeModal = lazy(
  () => import('../../components/student-welcome-modal/student-welcome-modal')
);
const ChecklistModal = lazy(() => import('../../components/checklist-modal/checklist-modal'));
const CollegeApplicationStatusModal = lazy(
  () =>
    import('../../../shared/college-application-status/containers/college-application-status-modal')
);
const MultimediaModal = lazy(() => import('src/components/multimedia-modal'));
const CommunityServiceModal = lazy(() => import('src/components/community-service-modal'));
const WorkExperienceModal = lazy(
  () => import('shared/portfolio/components/work-experiences/work-experience-modal')
);
const MultipleReferralModal = lazy(
  () => import('portfolio/components/multiple-referral-modal/multiple-referral-modal')
);
const ActivityModal = lazy(() => import('src/components/activity-modal'));
const CantEarnModal = lazy(() => import('../../components/cant-earn-modal/cant-earn-modal'));
const HonorAwardsModal = lazy(
  () => import('shared/portfolio/components/honor-awards/honor-awards-modal')
);
const CollegeCourseModal = lazy(
  () => import('shared/portfolio/components/courses/college-courses/college-course-modal')
);
const ShareModal = lazy(() => import('src/components/CollegeSearch/share-modal'));

const ModalRoutes = () => (
  <>
    <TermsOfUseModal />
    <Suspense fallback={null}>
      <Switch>
        <Route path="/colleges/welcome" component={WelcomeModal} />
        <Route path="/(.*)/college-success/:activity?/:type?/form" component={ActivitiesModal} />
        <Route path="/(.*)/course/:id" component={CollegeCourseModal} />
        <Route path="/(.*)/multimedia/:id" component={MultimediaModal} />
        <Route path="/(.*)/community-service/:id" component={CommunityServiceModal} />
        <Route path="/(.*)/work-experience/:id" component={WorkExperienceModal} />
        <Route path="/(.*)/refer" component={MultipleReferralModal} />
        <Route path="/(.*)/activity/:id" component={ActivityModal} />
        <Route path="/(.*)/honor-award/:id" component={HonorAwardsModal} />
        <Route path="/(.*)/new-earnings/:id" component={NewEarningsModal} />
        <Route path="/videos/video-welcome" component={VideoModal} />
        <Route path="/(.*)/application-status" component={CollegeApplicationStatusModal} />
        <Route path="/home/student-welcome" component={StudentWelcomeModal} />
        <Route path="/home/cant-earn" component={CantEarnModal} />
        <Route path="/(.*)/share-data" component={ShareDataModal} />
        <Route path="/(.*)/share" component={ShareModal} />
        <Route
          path="/checklist/checklist-welcome"
          render={(props) => (
            <ChecklistModal {...props} educationPhase={EducationPhase.COMMUNITY_COLLEGE} />
          )}
        />
        <Route
          path="/(.*)/invite"
          render={() => (
            <ReferralModal
              amount={50}
              learnMoreUrl="https://help.raise.me/hc/en-us/articles/115002094908-Student-Referrals-Give-100-Get-100"
            />
          )}
        />
      </Switch>
    </Suspense>
  </>
);

export default ModalRoutes;
